
import { defineComponent, PropType } from 'vue';
import { CatalogItem } from '@/common/services/swagger/index.defs';
import { Instance } from '@/catalogs/api/Instance';
import PIS from '@/common/api/PIS';
import { TranslateFunc } from '@/catalogs/composables/setupComponent';
import {
  CatalogActionCompleted,
  CatalogCopyActionCommand,
  CatalogDeleteActionCommand,
  CatalogEditActionCommand,
  CatalogExportActionCommand,
  CatalogImportActionCommand,
  CatalogMakeDefaultCommand,
  CatalogUnMakeDefaultCommand,
} from '@/catalogs/api/runtime/CommandExecutor';

export default defineComponent({
  components: {},
  props: {
    t: { type: Function as PropType<TranslateFunc>, required: true },
    instanceId: String,
    catalog: { type: Object as PropType<CatalogItem>, required: true },
    close: { type: Function, required: true },
  },
  setup(props) {
    const instance = PIS.Catalogs.getInstance(props.instanceId) as Instance;
    const onMakeDefault = async () => {
      if (!props.catalog.catalogId) {
        return;
      }
      try {
        await instance.execute(
          new CatalogMakeDefaultCommand({ catalogId: props.catalog.catalogId }),
        );
      } catch (error) {
        // Ignore Error
      }
    };
    const onUnMakeDefault = async () => {
      if (!props.catalog.catalogId) {
        return;
      }
      try {
        await instance.execute(
          new CatalogUnMakeDefaultCommand({ catalogId: props.catalog.catalogId }),
        );
      } catch (error) {
        // Ignore Error
      }
    };
    const onCatalogEditAction = async () => {
      try {
        instance.execute(new CatalogEditActionCommand({ catalog: props.catalog }));
      } catch (error) {
        // Ignore error
      }
    };
    const onCatalogCopyAction = async () => {
      try {
        instance.execute(new CatalogCopyActionCommand({ catalog: props.catalog }));
      } catch (error) {
        // Ignore error
      }
    };
    const onCatalogImportAction = async () => {
      try {
        instance.execute(new CatalogImportActionCommand({ catalog: props.catalog }));
      } catch (error) {
        // Ignore error
      }
    };
    const onCatalogExportAction = async () => {
      try {
        instance.execute(new CatalogExportActionCommand({ catalog: props.catalog }));
      } catch (error) {
        // Ignore error
      }
    };
    const onCatalogDeleteAction = async () => {
      try {
        instance.execute(new CatalogDeleteActionCommand({ catalog: props.catalog }));
      } catch (error) {
        // Ignore error
      }
    };
    const onActionCompleted = async () => {
      try {
        instance.execute(new CatalogActionCompleted());
      } catch (error) {
        // Ignore error
      }
    };
    return {
      onMakeDefault,
      onUnMakeDefault,
      onActionCompleted,
      onCatalogEditAction,
      onCatalogCopyAction,
      onCatalogImportAction,
      onCatalogExportAction,
      onCatalogDeleteAction,
    };
  },
});
